module.exports = __webpack_public_path__ + "img/banner1.dd3b51ce.png";